import { DownloadTemplate } from 'spw-programming-projects/downloads/types';
import { IAppState } from 'spw-redux/reducer';

export const selectIsDownloadingIndividualReport = (
  state: IAppState
): boolean => state.downloadsReducer.isDownloadingIndividualReport;

export const selectIndividualReportZipName = (state: IAppState): string =>
  state.downloadsReducer.zipName;

export const selectDownloadTemplates = (state: IAppState): DownloadTemplate[] =>
  state.downloadsReducer.downloadTemplates;

export const selectIsLoadingDownloadTemplates = (state: IAppState) =>
  state.downloadsReducer.isLoadingDownloadTemplates;

export const selectCurrentDownloadTemplate = (state: IAppState) =>
  state.downloadsReducer.currentDownloadTemplate;

export const selectIsLoadingCurrentTemplate = (state: IAppState) =>
  state.downloadsReducer.isLoadingCurrentTemplate;

export const selectDownloadsInProgress = (state: IAppState) =>
  state.downloadsReducer.downloadsInProgress;

export const selectFinishedProjectDownloads = (state: IAppState) =>
  state.downloadsReducer.finishedProjectDownloads;

export const selectFailedDownloadsTemplates = (state: IAppState) =>
  state.downloadsReducer.failedDownloadsTemplates;

export const selectNumberOfDownloadsInProgress = (state: IAppState) =>
  state.downloadsReducer.numberOfDownloadInProgress;

export const selectTemplatesWithDownloadsInProgressMap = (state: IAppState) =>
  state.downloadsReducer.templatesWithDownloadsInProgressMap;
